import { createDynamicSlice } from ".";
import { getExpenseListThunk } from "../thunks/addNewExpenseThunk";

export const addNewExpenseSlice = createDynamicSlice({
  name: "addNewExpenses",
  thunk: getExpenseListThunk,
  listMode: true,
  resetActionName: "resetAddNewExpenses",
});

export const addNewExpenseReducer = addNewExpenseSlice.reducer;
export const { resetAddNewExpenses } = addNewExpenseSlice.actions;
